(function () {
  var OPEN_KEY = 'pg_facet_open';

  function readOpen() {
    try { return JSON.parse(localStorage.getItem(OPEN_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeOpen(v) {
    try { localStorage.setItem(OPEN_KEY, JSON.stringify(v)); } catch (e) {}
  }

  function init() {
    var root = document.querySelector('[data-pg-facets]');
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    var rail = root.querySelector('[data-facet-rail]');
    var results = root.querySelector('[data-facet-results]');
    var sheetBody = root.querySelector('[data-facet-sheet-body]');
    var openBtn = root.querySelector('[data-facet-open]');
    var busy = false;

    /* ---------- group open state ---------- */
    function bindGroups(scope) {
      var state = readOpen();
      (scope || root).querySelectorAll('details.pgf__g').forEach(function (d) {
        if (d.dataset.gb === '1') return;
        d.dataset.gb = '1';
        var label = d.querySelector('summary span');
        var key = (label ? label.textContent.trim() : 'g').toLowerCase();
        if (Object.prototype.hasOwnProperty.call(state, key)) d.open = !!state[key];
        d.addEventListener('toggle', function () {
          var s = readOpen();
          s[key] = d.open;
          writeOpen(s);
          if (d.open) {
            root.querySelectorAll('details.pgf__g').forEach(function (other) {
              if (other !== d && other.open) other.open = false;
            });
          }
        });
      });
    }
    bindGroups();

    /* ---------- mobile sheet ---------- */
    function openSheet() {
      root.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }
    function closeSheet() {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    }
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest('[data-facet-open]')) { e.preventDefault(); openSheet(); return; }
      if (t.closest('[data-facet-close]')) { e.preventDefault(); closeSheet(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeSheet();
    });

    /* ---------- swap results in place ---------- */
    function swap(url, push) {
      if (busy) return;
      busy = true;
      if (results) results.classList.add('is-loading');

      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nRail = doc.querySelector('[data-facet-rail]');
          var nRes = doc.querySelector('[data-facet-results]');
          var nSheet = doc.querySelector('[data-facet-sheet-body]');
          var nDone = doc.querySelector('[data-facet-done]');
          var nCount = doc.querySelector('[data-facet-count]');
          var nTitle = doc.querySelector('[data-facet-title]');
          var nDesc = doc.querySelector('[data-facet-desc]');

          if (nRail && rail) { rail.innerHTML = nRail.innerHTML; }
          if (nRes && results) { results.innerHTML = nRes.innerHTML; }
          if (nSheet && sheetBody) { sheetBody.innerHTML = nSheet.innerHTML; }

          var done = root.querySelector('[data-facet-done]');
          if (nDone && done) done.textContent = nDone.textContent;
          var cnt = root.querySelector('[data-facet-count]');
          if (nCount && cnt) cnt.textContent = nCount.textContent;
          var ttl = root.querySelector('[data-facet-title]');
          if (nTitle && ttl) ttl.textContent = nTitle.textContent;
          var dsc = root.querySelector('[data-facet-desc]');
          if (nDesc && dsc) dsc.innerHTML = nDesc.innerHTML;

          if (push) history.pushState({ pgf: 1 }, '', url);
          document.title = doc.title;

          bindGroups();
          if (window.pgQuote) { document.dispatchEvent(new Event('shopify:section:load')); }
        })
        .catch(function () { window.location.href = url; })
        .then(function () {
          if (results) results.classList.remove('is-loading');
          busy = false;
        });
    }

    root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a.pgf__o, a.pgchip, a.pgf__reset, a.clearall') : null;
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) !== '/') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      swap(href, true);
    });

    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.pgf) swap(location.pathname + location.search, false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
